import React, { useState, useEffect } from 'react'
import styles from "./Table.module.scss";
import { useFormik } from 'formik';
import { CustomInput } from '../../assets/CustomInput/CustomInput'
import moment from 'moment';
import Loader from 'react-loader';
import Checkbox from '../../assets/Checkbox';
import PdfPrint from './PdfPrint';
import { createNotification } from '../notifications/notifications';
import * as Yup from 'yup';
import Confirmation from '../../assets/Confirmation/Confirmation';
import { set } from 'lodash';

const initialValues = {
    title: null,
    document_date: null,
    document_date_to: null,
    classification_mark: null,
    document_number: null,
    info: null,
    achievement_result: null
}


const initFileState = {
    link_type: 1,
    file: null,
    changed: false,
    link: ''
}

const Index = ({
    isOpen,
    onRequestClose,
    data,
    selectedItem,
    getAchievDetails,
    updateAchieveDetails,
    resetAchieveDetails,
    facultLabel,
    groupLabel,
    params,
    getAchieveFile,
    currentCell,
    setNewValue,
    setReport,
    mId,
    groupId,
    year,
    month,
    schema,
    group
}) => {
    const { patronymic, firstname, lastname, title, forgrant } = selectedItem || {}
    const fio = `${lastname} ${firstname} ${patronymic}`
    const forGrants = forgrant === true && !currentCell.cValue;

    const validationSchema = forgrant === true
        ? Yup.object().shape({
            title: Yup.string().required('Обязательное поле'),
            document_date: Yup.string().required('Обязательное поле'),
        })
        : Yup.object().shape({});


    const [confirmation, setConfirmation] = useState(false)
    const [validationAlert, setValidationAlert] = useState(false)
    const [loading, setLoading] = useState(false)
    const [file, setFile] = useState(initFileState)

    const getData = async () => {
        if (!isOpen) return setLoading(true);
        if (selectedItem.personnel_rating_id != 'new') {
            await getAchievDetails(selectedItem.personnel_rating_id)
        }
        setLoading(false)
    }

    useEffect(() => {
        getData()
        if (!isOpen) {
            resetAchieveDetails()
            resetForm()
        } else if (forgrant === true) {
            validateForm()
        }
    }, [isOpen])

    useEffect(() => {
        if (!data) {
            setValues(initialValues)
            setFile(initFileState)
            return;
        }
        const document_date = getDateFormatted(data.document_date)
        const document_date_to = getDateFormatted(data.document_date_to)
        const payload = { ...data, document_date, document_date_to }
        setValues(payload)
        const fileData = { link: data.link || '', link_type: data.link_type || 1 }
        setFile(fileData)
    }, [data])

    const getDateFormatted = date => date ? moment(date).format('YYYY-MM-DD') : null

    const updateDetails = async (values) => {
        const isForGrant = selectedItem.forgrant === true;
        const { mid, id, id_group, value, personnel_rating_id } = selectedItem;

        const { 
            classification_mark, 
            document_number, 
            title, 
            document_date, 
            document_date_to, 
            info, 
            achievement_result
        } = values;

        const payload = { 
            classification_mark, 
            document_number, 
            title, 
            document_date, 
            document_date_to, 
            info, 
            achievement_result
        };

        setLoading(true);
        if(selectedItem.personnel_rating_id == 'new') {
            await setReport(
                mid, 
                selectedItem.id, 
                year, 
                month, 
                value, 
                
                schema, 
                group, 
                {...payload, personnel_rating_id: personnel_rating_id}, 
                file, 
                params);
        } else {   
            await updateAchieveDetails(selectedItem.personnel_rating_id, payload, file, params);
        }
        onRequestClose();
        setLoading(false);
    }
    
    
    const {
        values,
        errors,
        touched,
        submitCount,
        resetForm,
        handleChange,
        setValues,
        handleSubmit,
        validateForm
    } = useFormik({
        initialValues,
        enableReinitialize: true,
        validationSchema,
        validateOnMount: true,
        validateOnChange: true,
        onSubmit: updateDetails
    })

    const fileTypeClickHandler = (fileType) => () => {
        setFile({ link_type: fileType, link: '' })
    }

    const selectFileHandler = e => {
        const file = e.target.files[0]
        setFile(prev => ({ ...prev, link: file.name, file, changed: true }))
    }

    const urlChangeHandler = e => setFile({ ...file, link: e.target.value, changed: true })

    const inputFileClickHandler = () => {
        document.getElementById('achieveFile').click()
    }

    const getFileHandler = () => {
        getAchieveFile(values.id, values.link)
    }

    const forGrantsCloseHandler = () => {
        const { mid, id } = selectedItem
        const cell = document.getElementById(`${mid}_${id}`);
        cell.value = '';
        onRequestClose()
        setConfirmation(false)
    }

    const submitClickHandler = (e) => {
        e.preventDefault()
        if (forgrant && (errors.title || errors.document_date)) {
            setValidationAlert(true)
            return
        }
        handleSubmit()
    }

    return (
        <>
            {validationAlert &&
                <div className={styles.validationOverlay}>
                    <div className={styles.validationModal}>
                        <div className={styles.validationText}>
                            Для сохранения факта наличия достижения необходимо заполнить поля Название и Дата
                        </div>
                        <button
                            className={styles.validationButton}
                            onClick={() => setValidationAlert(false)}
                        >
                            Хорошо
                        </button>
                    </div>
                </div>
            }
            {confirmation &&
                <Confirmation
                    title='Для сохранения факта наличия достижения необходимо заполнить поля Название и Дата. Закрыть без сохранения?'
                    confirmation={confirmation}
                    acceptConfirmation={forGrantsCloseHandler}
                    rejectConfirmation={() => setConfirmation(false)}
                />
            }
            <div
            className={`${styles.modalOverlay} ${isOpen ? styles.active : ''}`}
            onContextMenu={e => e.preventDefault()}
        >
            <div>
                <div>{`${fio} (${title})`}</div>
                <form onSubmit={submitClickHandler}>
                    <Loader loaded={!loading} color="#7b2b2a">
                        <CustomInput
                            label='Название'
                            value={values.title}
                            className={styles.input}
                            name='title'
                            onChange={handleChange}
                            error={errors['title']}
                            staticError
                            />
                        <CustomInput
                            label='Номер документа (при наличии)'
                            value={values.document_number}
                            className={styles.input}
                            name='document_number'
                            onChange={handleChange}
                            />
                        <CustomInput
                            label='Гриф (при наличии)'
                            value={values.classification_mark}
                            className={styles.input}
                            name='classification_mark'
                            onChange={handleChange}
                            />
                        <CustomInput
                            label='Дата'
                            value={values.document_date}
                            className={styles.input}
                            name='document_date'
                            onChange={handleChange}
                            type='date'
                            error={errors['document_date']}
                            staticError
                            />
                        <CustomInput
                            label='Срок действия (при наличии)'
                            value={values.document_date_to}
                            className={styles.input}
                            name='document_date_to'
                            onChange={handleChange}
                            type='date'
                            />
                        <CustomInput
                            label='Результат'
                            value={values.achievement_result}
                            className={styles.input}
                            name='achievement_result'
                            onChange={handleChange}
                            />
                        <CustomInput
                            label='Дополнительная информация, которую необходимо указать'
                            value={values.info}
                            className={styles.input}
                            name='info'
                            onChange={handleChange}
                        />
                        <div className={styles.filesBlock}>
                            <div>
                                <Checkbox value={file.link_type == 1} label='файл' onClick={fileTypeClickHandler(1)} />
                                <Checkbox value={file.link_type == 2} label='ссылка' onClick={fileTypeClickHandler(2)} />
                            </div>
                            {
                                file.link_type == 1
                                    ? <>
                                        <p onClick={getFileHandler}>{file.link}</p>
                                        <input type="file" id='achieveFile' onChange={selectFileHandler} hidden />
                                        <button type='button' onClick={inputFileClickHandler}>Выбрать файл</button>
                                    </>
                                    : <>
                                        <input type="text" value={file.link} onChange={urlChangeHandler} />
                                    </>
                            }
                        </div>
                        <div className={styles.buttonsBlock}>
                            <button onClick={() => forGrants ? setConfirmation(true) : onRequestClose()} type='button'>Закрыть</button>
                            <button type='submit'>Сохранить</button>
                            <PdfPrint
                                data={values}
                                fio={fio}
                                facultLabel={facultLabel}
                                groupLabel={groupLabel}
                            />
                        </div>
                    </Loader>
                </form>
            </div>
        </div>
        </>
    )
}

export default Index
